import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_ORG_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_DASHBOARD_CONFIG_ID } from 'routes/libra-dashboard/-searchParams'
import { Route as NewRoute } from 'routes/libra-dashboard/index'

export const Route = createFileRoute(
  '/libra-dashboard/(deprecated_routes)/$orgID/$dashboardConfigId'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_ORG_ID]: params.orgID,
        [SEARCH_PARAM_DASHBOARD_CONFIG_ID]: params.dashboardConfigId,
      }),
      replace: true,
    })
  },
})
